import { SVGProps } from '@components/Icon/types';

export const Case = ({ fill = '#000', size = 24, ...props }: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.3019 5.32075H16.1509V3.66038C16.1509 2.74717 15.4038 2 14.4906 2H9.50943C8.59623 2 7.84906 2.74717 7.84906 3.66038V5.32075H3.69811C2.20377 5.32075 1 6.52453 1 8.01887V19.6415C1 21.1358 2.20377 22.3396 3.69811 22.3396H20.3019C21.7962 22.3396 23 21.1358 23 19.6415V8.01887C23 6.52453 21.7962 5.32075 20.3019 5.32075ZM9.09434 3.66038C9.09434 3.43208 9.28113 3.24528 9.50943 3.24528H14.4906C14.7189 3.24528 14.9057 3.43208 14.9057 3.66038V5.32075H9.09434V3.66038ZM5.15094 21.0943H3.69811C2.88868 21.0943 2.24528 20.4509 2.24528 19.6415V8.01887C2.24528 7.20943 2.88868 6.56604 3.69811 6.56604H5.15094H6.39623H17.6038H18.8491H20.3019C21.1113 6.56604 21.7547 7.20943 21.7547 8.01887V19.6415C21.7547 20.4509 21.1113 21.0943 20.3019 21.0943H18.8491H17.6038H6.39623H5.15094Z"
      fill={fill}
    />
    <path d="M17.6038 6.56604V21.0943H18.8491V6.56604H17.6038Z" fill={fill} />
    <path d="M5.15094 6.56604V21.0943H6.39623V6.56604H5.15094Z" fill={fill} />
  </svg>
);

export const ICON_NAME = 'case';
